import { useState, useEffect } from "react";

export default function useScrollDirection(enabled = true) {
  const [scrollDir, setScrollDir] = useState("up");

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    let lastScrollY = window.pageYOffset;
    const threshold = 10; // minimum pixels scrolled before updating

    const updateScrollDir = () => {
      const scrollY = window.pageYOffset;
      if (Math.abs(scrollY - lastScrollY) < threshold) {
        return;
      }
      setScrollDir(scrollY > lastScrollY ? "down" : "up");
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };

    window.addEventListener("scroll", updateScrollDir, { passive: true });

    return () => {
      window.removeEventListener("scroll", updateScrollDir);
    };
  }, [enabled]);

  return scrollDir;
}
